import { TariffCategory } from '../../shared/models/types'
import { TariffDto } from '../api/dto/tariffs.dto'
import { TariffModel } from '../models/tariffs-model'
import { tariffStatus } from '../utils/tariff-status'

/**
 * Function for transforming tariff dto to front-end model
 * @param tariff - as array of TariffDto
 * @param isDynamicElectricityActive - boolean for dynamic electricity indicator
 * @returns array of TariffModel
 */
export const tariffDtoToModel = (tariff: TariffDto, isDynamicElectricityActive: boolean): TariffModel => {
  const staticPrices = (tariff: TariffDto): { grid: number; solar: number | null; vat: number } => {
    const tempGridPrice = tariff.coreTariffDto.elements[0].price_components.find(price => price.type === 'ENERGY')?.price
    const tempSolarPrice = tariff.coreTariffDto.elements[0].price_components.find(price => price.type === 'FLAT')?.price

    return {
      grid: tempGridPrice ?? 0,
      solar: tempSolarPrice ?? null,
      vat: tariff.coreTariffDto.elements[0].price_components.map(price => price.vat)[0] ?? 0,
    }
  }

  return {
    tariffId: tariff.tariffId,
    tariffName: tariff.tariffName,
    currencyCode: tariff.coreTariffDto.currency,
    tariffCategory: tariff.tariffCategory,
    installationId: tariff.installationId,
    wallboxConnector: tariff.wallboxConnector,
    connectorId: tariff.connectorId,
    startTime: tariff.coreTariffDto.start_date_time ? tariff.coreTariffDto.start_date_time : null,
    endTime: tariff.coreTariffDto.end_date_time ? tariff.coreTariffDto.end_date_time : null,
    lastUpdated: tariff.lastUpdated,
    createdBy: tariff.createdBy ?? '',
    staticPrices: {
      gridPrice: staticPrices(tariff).grid,
      solarPrice: staticPrices(tariff).solar,
      vat: staticPrices(tariff).vat,
    },
    dynamicPrices:
      tariff.tariffCategory === TariffCategory.dynamicTariff
        ? tariff.coreTariffDto.elements.map(element => {
            return {
              gridPrice: element.price_components.map(price => price.type === 'ENERGY' && price.price)[0] || 0,
              solarPrice: element.price_components.map(price => price.type === 'FLAT' && price.price)[0] || 0,
              startDateTime: element.restrictions?.start_date_time,
              endDateTime: element.restrictions?.end_date_time,
            }
          })
        : [],
    dischargePrice: tariff.dischargePrice,
    tariffStatus: tariffStatus({
      start: new Date(tariff.coreTariffDto.start_date_time ?? ''),
      end: new Date(tariff.coreTariffDto.end_date_time ?? ''),
      isDynamicElectricityActive,
      tariffCategory: tariff.tariffCategory,
    }),
  }
}
